import React, { useCallback } from "react";
import { EntryModel, TextData } from 'lib/models';
import EntryContentContainer from 'components/MoveableEntry/EntryContentContainer';
import TextEditor from "components/TextEditor";
import { updateEntry } from "lib/api";

interface TextEntryProps {
  refId: string;
  model: EntryModel<TextData>;
}

function TextEntry({model}: TextEntryProps) {

  const saveText = useCallback(async (updatedText: string): Promise<void> => {
    const updatePatch: Partial<TextData> = {text: updatedText};
    await updateEntry(model.uuid, model.data.type, updatePatch);
    model.data.text = updatedText;
  }, [model.uuid, model.data.type]);

  return (
    <div className="pr-2 py-2 bg-blue-200 rounded-lg h-full w-full">
      <EntryContentContainer className="h-full w-full" >
        <TextEditor
          initialText={model.data.text}
          onChangeThrottled={saveText}
          readOnly={false}
        />
      </EntryContentContainer>
    </div>
  );
}

export default TextEntry;
